import { ApplicationRef, NgModuleRef } from '@angular/core';
import { createNewHosts } from '@angularclass/hmr';

/**
 * Interface representing the Webpack/Vite 'module' object with HMR capabilities
 */
export interface HmrModule {
  hot: {
    accept: () => void;
    dispose: (callback: (data: unknown) => void) => void;
    data?: unknown;
  };
}

/**
 * Strongly typed HMR bootstrap wrapper
 * @param module The global 'module' variable
 * @param bootstrap The function that triggers platformBrowserDynamic().bootstrapModule(...)
 */
export const hmrBootstrap = <T>(
  module: HmrModule,
  bootstrap: () => Promise<NgModuleRef<T>>
): void => {
  let ngModule: NgModuleRef<T>;

  module.hot.accept();

  bootstrap().then((mod) => (ngModule = mod));

  module.hot.dispose(() => {
    const appRef: ApplicationRef = ngModule.injector.get(ApplicationRef);
    const elements = appRef.components.map((c) => c.location.nativeElement);
    const makeVisible = createNewHosts(elements);

    ngModule.destroy();
    makeVisible();
  });
};
